export default "__VITE_ASSET__BfL2LaZG__"